<template>
  <div>
    <table class="ui celled table">
      <tbody>
        <tr>
          <td class="label">
            {{ $t('Name') }}
          </td>
          <td>
            {{ customer.firstname }} {{ customer.lastname }}
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t('Email') }}</td>
          <td>{{ customer.email }}</td>
        </tr>
      </tbody>
    </table>
    <address-modal>
      <button slot="activator" class="ui blue button mb-2">
        <i class="add icon"></i>{{ $t('Add a new address') }}
      </button>
    </address-modal>
    <div
      v-if="customer.addresses.length > 0"
      class="addresses-content"
    >
      <table class="ui celled table">
        <tbody>
          <tr
            v-for="(address, index) in customer.addresses"
            :key="index"
          >
            <td>
              <div>
                <strong>{{ address.alias }}</strong>
              </div>
              <div>{{ address.firstname }} {{ address.lastname }}</div>
              <div>{{ address.address1 }} {{ address.address2 }}</div>
              <div>{{ address.postcode }} {{ address.city }}</div>
              <div>{{ getCountryNameFromId(address.id_country) }}</div>
              <div>{{ $t('Phone') }}: {{ address.phone }}</div>
              <div>
                {{ $t('Phone (Mobile)') }}: {{ address.phone_mobile }}
              </div>
            </td>
            <td style="width: 150px">
              <address-modal
                mode="edit"
                :address_to_edit="customer.addresses[index]"
                @input="updateEditedAddress($event, index)"
              >
                <button
                  slot="activator"
                  class="ui icon button purple right aligned"
                >
                  <i class="icon edit"></i>
                </button>
              </address-modal>
              <button
                class="ui icon button red right aligned"
                @click="askDeleteAddress(address)"
              >
                <i class="icon trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <popup-modal
      :index="address_to_delete"
      icon="delete"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Are you sure you want to delete this address ?"
      @cancel="address_to_delete = null"
      @delete="deleteAddress"
    ></popup-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import AddressModal from '../../components/Modal/AddressModal'

export default {
  name: 'AddressTab',
  components: {
    AddressModal
  },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      address_to_delete: null,
    }
  },
  mounted() {
    this.refreshCustomerAddresses()
  },
  computed: {
    ...mapGetters({
      countries: 'getCountries'
    })
  },
  methods: {
    refreshCustomerAddresses() {
      return axios
        .get(`/customer/${this.customer.id}/addresses`)
        .then((response) => {
          this.$store.dispatch(
            'setCurrentCustomerAddresses',
            response.data.addresses
          )
        })
    },
    getCountryNameFromId(idCountry) {
      let name = null
      this.countries.some((country) => {
        if (country.id_country === idCountry) {
          name = country.name
          return true
        }
        return false
      })
      return name
    },
    askDeleteAddress(address) {
      this.address_to_delete = address
    },
    deleteAddress(address) {
      return axios.delete(`/addresses/${address.id}`, address).then(() => {
        this.$store.dispatch('deleteAddress', address)
        this.address_to_delete = null
      })
    },
    updateEditedAddress(newAddress, index) {
      Vue.set(this.customer.addresses, index, newAddress)
      this.$store.dispatch(
        'setCurrentCustomerAddresses',
        this.customer.addresses
      )
    }
  }
}
</script>

<style scoped>
.addresses-content .separator {
  padding-left: 10px;
  padding-right: 10px;
}
</style>


// WEBPACK FOOTER //
// AddressTab.vue?15b2c8fe